<template>
	<div
		class="conversation-history"
		ref="ConversationHistory"
		infinite-wrapper
	>
		<infinite-loading
			direction="top"
			@infinite="infiniteHandler"
			spinner="waveDots"
			:forceUseInfiniteWrapper="true"
			:distance="50"
		>
			<span slot="no-results">Error while loading data :/</span>
			<span slot="no-more">You've reached the very top :o</span>
		</infinite-loading>
		<div
			class="sticky-date-separator divider text-center"
			:visible="showStickyDateSeparator"
			:data-content="stickyDateSeparator"
		></div>
		<div
			v-for="(message, index) in loadedMessages"
			:class="
				'message-container ' +
					(isNewDay(index) ? 'isnewday ' : '') +
					(isFollowUp(index) ? 'isfollowup ' : '') +
					(!isFollowUp(index + 1) ? 'isfollowlast ' : '') +
					(isOwn(index) ? 'isown ' : '')
			"
			:key="'message_' + message.key"
			:date-added="message.dateAdded"
			:message-key="message.key"
		>
			<div
				v-if="isNewDay(index)"
				class="date-separator divider text-center"
				:data-content="dateSeparator(message.dateAdded)"
			></div>
			<div class="user-avatar_message">
				<div
					v-if="!isFollowUp(index + 1)"
					class="user-avatar-action-dropdown"
				>
					<!-- <Dropdown v-if="!isFollowUp(index)" class="user-avatar-action-dropdown" :items="['a', 'b', 'c']" :align="isOwn ? 'right' : 'left'" @update:active="dropdownActive = $event" :active="dropdownActive">
                    <template v-slot:activator="scope"> -->
					<UserAvatar
						:providerName="message.providerName"
						:userId="message.userId"
						:userName="message.userName"
						class="rounded"
					/>
					<!-- </template>
                    <template v-slot:item="scope">
                        <button class="user-avatar-action-dropdown-menu-li btn link" @click.stop="scope.on()">{{ scope.item }}</button>
                    </template>
                    </Dropdown> -->
				</div>
				<Message
					:message="message"
					:isFollowUp="isFollowUp(index)"
					:isOwn="isOwn(index)"
				/>
			</div>
		</div>
		<br />
		<button
			class="scroll2bottom-btn btn lg action rounded shadow secondary"
			@click="scrollToBottom()"
			:scrolled-to-bottom="scrolledToBottom"
		>
			<icon>arrow-down</icon>
		</button>
	</div>
</template>

<script>
import Icon from './Icon';
// import Dropdown from './Dropdown';
import Message from './Message.vue';
import UserAvatar from './UserAvatar.vue';
import InfiniteLoading from 'vue-infinite-loading';
import moment from 'moment';
import { mapGetters } from 'vuex';

let ticking = false;
let scrollTimeout = null;

export default {
	name: 'ConversationHistory',
	components: {
		Icon,
		// Dropdown,
		Message,
		UserAvatar,
		InfiniteLoading
	},
	data() {
		return {
			loadedMsgNr: 0,
			loadedMessages: [],
			stickyDateSeparator: '',
			showStickyDateSeparator: false,
			scrolledToBottom: true
			// dropdownActive: false
		};
	},
	mounted() {
		this.loadMsgs(25, () => {
			this.$nextTick(() => {
				this.$refs.ConversationHistory.scrollTop = this.$refs.ConversationHistory.scrollHeight;
			});
		});
		this.$el.addEventListener('scroll', () => {
			this.scrollUpdater();
		});
		this.$nextTick(() => {
			this.scrollUpdater();
		});
	},
	computed: {
		curdate() {
			return moment().format('MMMM Do, YYYY');
		},
		...mapGetters(['curConversation']),
		...mapGetters({
			getCurConversationMessages:
				'ConversationProviders/getCurConversationMessages',
			getCurConversationUser:
				'ConversationProviders/getCurConversationUser'
		})
	},
	methods: {
		infiniteHandler($state) {
			this.$store
				.dispatch(
					'ConversationProviders/provider_' +
						this.curConversation.providerName +
						'/fetchMessages',
					this.curConversation.conversationId
				)
				.then(({ conversationId, totalPages, page, slice }) => {
					console.debug(
						'fetchMessages',
						conversationId,
						totalPages,
						page,
						slice
					);

					if (
						typeof slice === 'object' &&
						slice.hasOwnProperty('length') &&
						slice.length > 0
					) {
						this.loadedMessages.unshift(...slice);

						if (page === 0) {
							console.debug('infiniteHandler: complete');
							$state.complete();
						} else if (page > 0) {
							console.debug('infiniteHandler: loaded');
							$state.loaded();
						}
					} else {
						this.loadMsgs(10, (err, status) => {
							console.debug('loadMsgs', err, status);

							if (err) {
								console.debug('infiniteHandler: error');
								$state.error();
							} else if (status === 0 /* || page >= 0*/) {
								console.debug('infiniteHandler: loaded');
								$state.loaded();
							} else if (status === 1) {
								console.debug('infiniteHandler: complete');
								$state.complete();
							} else {
								console.debug('infiniteHandler: error 2');
								$state.error();
							}
						});
					}
				})
				.catch(() => {
					console.debug('infiniteHandler: error');
					$state.error();
				});
		},
		scrollUpdater() {
			let convhist = this.$el;
			let last_known_scroll_position = convhist.scrollTop;

			if (scrollTimeout) {
				clearTimeout(scrollTimeout);
			}

			if (!ticking) {
				window.requestAnimationFrame(() => {
					if (
						last_known_scroll_position >=
						convhist.scrollHeight - convhist.clientHeight - 128
					) {
						this.scrolledToBottom = true;
					} else {
						this.scrolledToBottom = false;
					}

					let lowerD = 0;

					let newdayMessageContainers = convhist.getElementsByClassName(
						'message-container isnewday'
					);

					this.stickyDateSeparator = '';
					this.showStickyDateSeparator = true;

					for (
						let elI = 0;
						elI < newdayMessageContainers.length;
						elI++
					) {
						let el = newdayMessageContainers[elI];

						let distance =
							el.offsetTop - 34 - last_known_scroll_position;
						let first = last_known_scroll_position >= distance;
						let second = distance >= lowerD;
						let third = distance <= 0;
						if (first && (second || lowerD === 0) && third) {
							lowerD = distance;

							this.stickyDateSeparator = this.dateSeparator(
								el.getAttribute('date-added')
							);
						}
					}

					ticking = false;

					scrollTimeout = setTimeout(() => {
						this.stickyDateSeparator = '';
						this.showStickyDateSeparator = false;
					}, 2500);
				});

				ticking = true;
			}
		},
		loadMsgs(maxTries = 5, cb) {
			let curConvMsgs = this.getCurConversationMessages;

			if (this.loadedMsgNr < curConvMsgs.length) {
				let curTries = 0;

				let lmsgs = [];

				while (
					this.loadedMsgNr < curConvMsgs.length &&
					curTries < maxTries
				) {
					let newConvMsg = curConvMsgs[this.loadedMsgNr];
					lmsgs.unshift(newConvMsg);
					curTries++;
					this.loadedMsgNr++;
				}

				this.loadedMessages = this.loadedMessages.filter(msg1 => {
					return (
						curConvMsgs.findIndex(msg2 => {
							return msg1.key === msg2.key;
						}) !== -1
					);
				});

				this.loadedMessages.unshift(...lmsgs);

				console.debug(
					'loaded',
					curTries,
					'messages (total loaded',
					this.loadedMsgNr,
					'/',
					curConvMsgs.length,
					')',
					lmsgs
				);

				if (this.loadedMsgNr >= curConvMsgs.length) {
					typeof cb === 'function' && cb(null, 1);
				} else {
					typeof cb === 'function' && cb(null, 0, lmsgs);
				}
			} else {
				typeof cb === 'function' && cb(null, 1);
			}
		},
		dateSeparator(ts) {
			return moment(ts, 'x').format('MMMM Do, YYYY') === this.curdate
				? 'Today'
				: moment(this.curdate, 'MMMM Do, YYYY')
						.subtract(1, 'd')
						.format('MMMM Do, YYYY') ===
				  moment(ts, 'x').format('MMMM Do, YYYY')
				? 'Yesterday'
				: moment(ts, 'x').format('MMMM Do, YYYY');
		},
		isFollowUp(mI) {
			if (mI <= 0 || mI > this.loadedMessages.length - 1) return false;

			let lmsg = this.loadedMessages[mI - 1];
			let msg = this.loadedMessages[mI];

			return (
				msg.userId === lmsg.userId &&
				moment(lmsg.dateAdded, 'x')
					.add(15, 'minutes')
					.isSameOrAfter(moment(msg.dateAdded, 'x'))
			);
		},
		isNewDay(mI) {
			if (mI <= 0) return true;

			let lmsg = this.loadedMessages[mI - 1];
			let msg = this.loadedMessages[mI];

			return !moment(lmsg.dateAdded, 'x').isSame(
				moment(msg.dateAdded, 'x'),
				'day'
			);
		},
		isOwn(mI) {
			let msg = this.loadedMessages[mI];

			return msg.userId == this.getCurConversationUser.userId;
		},
		scrollToBottom() {
			let convhist = this.$el;
			convhist.scroll({
				top: convhist.scrollHeight,
				behavior: true ? 'smooth' : 'instant'
			});
		}
	},
	watch: {
		getCurConversationMessages(curConvMsgs, oldConvMsgs) {
			// console.debug(
			//     'getCurConversationMessages',
			//     oldConvMsgs,
			//     curConvMsgs,
			//     oldConvMsgs.length > 0 && oldConvMsgs[0].key,
			//     curConvMsgs.length > 0 && curConvMsgs[0].key
			// );

			if (
				oldConvMsgs.length > 0 &&
				curConvMsgs.length > 0 &&
				curConvMsgs[0].key === oldConvMsgs[0].key
			)
				return false;

			let convhist = this.$el;
			let convhist_scrollTop = convhist.scrollTop;
			let convhist_scrollHeight = convhist.scrollHeight;
			let convhist_clientHeight = convhist.clientHeight;

			let maxTries = curConvMsgs.length - oldConvMsgs.length;
			let curTries = 0;

			let lmsgs = [];

			while (curTries < maxTries) {
				let newConvMsg = curConvMsgs[curTries];
				lmsgs.unshift(newConvMsg);
				curTries++;
				this.loadedMsgNr++;
			}

			this.loadedMessages = this.loadedMessages.filter(msg1 => {
				return (
					curConvMsgs.findIndex(msg2 => {
						return msg1.key === msg2.key;
					}) !== -1
				);
			});

			this.loadedMessages.push(...lmsgs);

			console.debug(
				'n-loaded',
				curTries,
				'messages (total loaded',
				this.loadedMsgNr,
				'/',
				curConvMsgs.length,
				')',
				lmsgs
			);

			this.$nextTick(() => {
				if (
					convhist_scrollTop >=
					convhist_scrollHeight - convhist_clientHeight - 128
				) {
					convhist.scroll({
						top: convhist.scrollHeight,
						behavior: true ? 'smooth' : 'instant'
					});
				}
			});
		},
		scrolledToBottom(newval) {
			this.$emit('update:scrolledToBottom', newval);
		}
	}
};
</script>
